import { useState } from "react"
import styles from "../../analytics.module.css"

export default function ConfirmDeleteAlertModal({ isOpen, onClose, onConfirm, alert }) {
    if (!isOpen) return null
    const [loading, setLoading] = useState(false)

    const handleConfirm = async () => {
        setLoading(true)
        await onConfirm(alert._id)
        setLoading(false)
        onClose()
    }

    const handleCancel = () => {
        onClose()
    }

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose()
        }
    }

    return (
        <div className={styles.modalOverlay} onClick={handleOverlayClick}>
            <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                <div className={styles.modalHeader}>
                    <h2>Confirm Delete Alert</h2>
                    <button className={styles.closeButton} onClick={handleCancel}>
                        ×
                    </button>
                </div>


                <div className={styles.confirmationContent}>
                    <div className={styles.warningIcon}>
                        ⚠️
                    </div>

                    <p className={styles.confirmationText}>
                        Are you sure you want to delete the alert:
                    </p>

                    <div className={styles.alertTitle}>
                        "{alert.title}"
                    </div>

                    <p className={styles.warningText}>
                        This action cannot be undone.
                    </p>
                </div>

                <div className={styles.confirmationActions}>
                    <button
                        onClick={handleCancel}
                        className={styles.secondaryButton}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleConfirm}
                        className={styles.dangerButton}
                    >
                        {loading ? "Deleting..." : "Delete Alert"}
                    </button>
                </div>
            </div>
        </div>
    )
}